import React, { useEffect } from 'react';

const KakaoShareButton = ({ title, description, imageUrl, resultPath }) => {
  useEffect(() => {
    // 1. 카카오 SDK가 로드되었는지 확인하고 초기화
    if (window.Kakao) {
      if (!window.Kakao.isInitialized()) {
        // 여기에 아까 복사한 [JavaScript 키]를 넣으세요!
        window.Kakao.init('86f74dcd903e52674f83e9a5b76e9b6f');
      }
    }
  }, []);

  const shareKakao = () => {
    if (window.Kakao) {
      window.Kakao.Share.sendDefault({
        objectType: 'feed',
        content: {
          title: title,
          description: description,
          imageUrl: imageUrl || 'https://your-default-image.png', // 공유 시 보여줄 이미지
          link: {
            mobileWebUrl: window.location.href,
            webUrl: window.location.href,
          },
        },
        buttons: [
          {
            title: '테스트 결과 보기',
            link: {
              mobileWebUrl: window.location.href,
              webUrl: window.location.href,
            },
          },
        ],
      });
    }
  };

  return (
    <button
      onClick={shareKakao}
      className="bg-[#FEE500] text-[#000000] px-8 py-4 rounded-full font-bold text-lg w-full shadow-lg hover:bg-[#FADA00] transition-colors"
    >
      카카오톡으로 결과 공유하기
    </button>
  );
};

export default KakaoShareButton;
